"use strict";

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

var _QuestionDialog = _interopRequireDefault(require("material-ui-shell/lib/components/QuestionDialog/QuestionDialog"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Provider = function Provider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)({
    isOpen: false
  }),
      state = _useState[0],
      setState = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      isProcessing = _useState2[0],
      setIsProcessing = _useState2[1];

  var openDialog = function openDialog(props) {
    setState(_extends({
      isOpen: true
    }, props));
  };

  var closeDialog = function closeDialog() {
    setState({
      isOpen: false
    });
  };

  var setProcessing = function setProcessing(isProcessing) {
    setIsProcessing(isProcessing);
  };

  return /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: {
      openDialog: openDialog,
      closeDialog: closeDialog,
      setProcessing: setProcessing
    }
  }, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children, /*#__PURE__*/_react.default.createElement(_QuestionDialog.default, _extends({
    handleClose: closeDialog,
    isProcessing: isProcessing
  }, state))));
};

Provider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.any
} : {};
var _default = Provider;
exports.default = _default;
module.exports = exports.default;